import {
  textareaUI,
  textareaSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import {
  additionalInformationPageTitle,
  additionalInformationPageQuestion,
} from '../content/additionalInformationPage';
import {
  titleWithTag,
  form0781HeadingTag,
  mentalHealthSupportAlert,
} from '../content';

export const uiSchema = {
  'ui:title': titleWithTag(additionalInformationPageTitle, form0781HeadingTag),
  additionalInformation: textareaUI({
    title: additionalInformationPageQuestion,
  }),
  'view:mentalHealthSupportAlert': {
    'ui:description': mentalHealthSupportAlert,
  },
};

export const schema = {
  type: 'object',
  properties: {
    additionalInformation: textareaSchema,
    'view:mentalHealthSupportAlert': {
      type: 'object',
      properties: {},
    },
  },
};
